import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const interviewNotificationService = {
  async getNewNotifications(since) {
    try {
      const response = await axios.get(`${API_URL}/applications/interview-notifications`, {
        params: { since: since.toISOString() }
      });
      return response.data.notifications || [];
    } catch (error) {
      console.error('Error fetching interview notifications:', error);
      return [];
    }
  }
};
